import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Col, Row, Card, Form } from '@themesberg/react-bootstrap'
import { Context } from '../CashbackHistory'
import { getSummaryCashbackHistory } from '../../../../../controller/api/cashbackHistory';
import { useCookies } from 'react-cookie';

const _Summary = () => {

  const { state } = useContext(Context);

  const [cookies] = useCookies(['lottmekong'])

  const [data, setData] = useState({
    count: 0,
    total: '0',
  })

  const getSummaryFunc = useCallback(async () => {
    const response = await getSummaryCashbackHistory(cookies.lottmekong, {
      from: state.filter.from,
      to: state.filter.to,
      phone: state.filter.phone,
      ref: state.filter.ref,
      kind: state.filter.kind,
    })

    if (response) {
      setData({
        count: response.count,
        total: response.total
      })
    }
  }, [cookies.lottmekong, state.filter.from, state.filter.to, state.filter.phone, state.filter.ref, state.filter.kind])

  useEffect(() => {
    getSummaryFunc()
  }, [getSummaryFunc, state.filterPressCount])

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Body>
          <Col>
            <Row>
              <Col>
                <Row md={12} className='text-center align-self-center'>
                  <Form.Label>Số lần hoàn</Form.Label>
                </Row>
                <Row md={12} className='text-center align-self-center'>
                  <Form.Label>{data.count}</Form.Label>
                </Row>
              </Col>
              <Col>
                <Row md={12} className='text-center align-self-center'>
                  <Form.Label>Tổng tiền</Form.Label>
                </Row>
                <Row md={12} className='text-center align-self-center'>
                  <Form.Label>{new Intl.NumberFormat('vn-VI', {}).format(data.total) || ""}</Form.Label>
                </Row>
              </Col>
            </Row>
          </Col>
        </Card.Body>
      </Card>
    </>
  );
};

export default React.memo(_Summary)
